import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=61115b6b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=61115b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61115b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61115b6b')) {
      api.createRecord('61115b6b', component.options)
    } else {
      api.reload('61115b6b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=61115b6b&scoped=true&", function () {
      api.rerender('61115b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w9mqpECp4mbc/JS/comp/SearchFilterTokens.vue"
export default component.exports